var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechPlayground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neutral_11_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M477.6,391.1c-4-3.2-9.8-2.6-13,1.4c-0.1,0.2-4.5,5.5-12.7,12.8c-6-15.6-20.4-42.6-50.1-55.4 c0.1-1.3,0-2.6-0.4-3.9c-0.3-0.9-0.8-1.8-1.4-2.6l-44-189c14.6-12,14.5-38.4,14.5-53.7c-0.1-27-11.1-58.2-11.5-59.5l-2.9-8.1 L270.4,56l2.2,9c0.3,1.3,7.9,31.3,19,54.7c3,6.3,6.8,12.8,11.3,18.7c-33.6,7.3-108.6,31.5-125.7,103.8 c-58.1,41.6-70.9,109.3-73.3,126.9c-58.5,9.5-83.1,66.1-84.2,68.7c-2,4.8,0.2,10.2,4.9,12.3c4.7,2.1,10.1-0.2,12.1-4.9 c1-2.4,25.6-58.8,83.9-58.8c29.6,0,63.5,18.3,99.5,37.6c39,21,79.4,42.8,118.7,42.8c89.8,0,138.2-59.9,140.3-62.5 C482.2,400.3,481.6,394.4,477.6,391.1z M372.9,308.9c-8.5,3.5-26.8,9.5-51,9.5c-9.7,0-19.5-3.5-28.3-8.2 c22.6-5.2,39.5-25.8,39.5-50.3c0-28.2-22.4-51.1-50.1-51.5c14-10.2,32.6-16.1,62-18.8L372.9,308.9z M282.3,292.7 c-17.8,0-32.3-14.7-32.3-32.8c0-18.1,14.5-32.8,32.3-32.8c17.8,0,32.3,14.7,32.3,32.8C314.7,278,300.2,292.7,282.3,292.7z  M293,69.4l51.1-13.6c3.1,10.4,7.8,29,7.9,45.1c0.1,19.8-1.2,38.4-11.1,40.7c-9.4,2.3-23.4-10.6-32.6-30 C301.5,97.3,296,79.8,293,69.4z M375,444.1c-10.9,2.4-22.7,3.9-35.6,3.9c-8.2-14.8-38.1-62.7-94.3-82.5c1.3-3.6,3.6-7.8,6-11.4 c12.5,5.2,40.1,14.9,72,14.9c23,0,42-3.1,54.9-6.1C371.7,374.8,366.2,397.2,375,444.1z M323.2,350.3c-38.2,0-70.6-15.9-70.9-16.1 l-6.5-3.2l-4.7,5.6c-2.8,3.3-16.6,20.7-15.6,36.1l0.4,6.6l6.2,1.8c42.8,12.5,70.3,44.8,83.6,64.2c-28.2-6.2-58-22.1-87.1-37.8 c-37.2-20-72.4-38.9-105.9-39.7c3.4-20.1,17.4-77.8,67.7-112.1l3.1-2.1l0.8-3.7c15.6-76.1,110.7-93.2,125-95.3 c5.9,3.8,12.2,6.2,18.9,6.2h0.1l2.4,10.4c-51.4,5.1-76.7,20.4-100.9,59.3c-0.6,1-1,2.1-1.3,3.2c-4.5,7.7-7.2,16.7-7.2,26.3 c0,13.8,5.4,26.4,14.1,35.6c0.1,0.1,0.1,0.1,0.2,0.2c1.5,1.7,37.1,41.4,76.1,41.4c24.8,0,44.3-5.7,55.2-9.8l3.7,15.7 C369.8,345.9,349,350.3,323.2,350.3z M392.9,439.3c-8.8-47.9-1.2-64.3,4-71.2c25.6,12.3,36.4,39.1,39.7,49.2 C425.2,425.2,410.7,433.4,392.9,439.3z"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechPlayground;